document.addEventListener("DOMContentLoaded", function () {
  const offerBlocks = document.querySelectorAll(".product-offer__block");

  offerBlocks.forEach((block) => {
    block.addEventListener("click", function () {
      const offerCode = block.getAttribute("data-offer-code");

      if (offerCode) {
        navigator.clipboard
          .writeText(offerCode)
          .then(() => {
            showCopiedMessage(block);
          })
          .catch((err) => {
            console.error("Copy failed", err);
          });
      }
    });
  });

  function showCopiedMessage(targetBlock) {
    const message = document.createElement("span");
    message.innerText = "Copied!";
    message.className = "copied-message";
    message.style.cssText = `
        position: absolute;
        background: #c41320;
        color: white;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
        top: -20px;
        right: 10px;
        z-index: 1000;
        animation: fadeOut 2s forwards;
      `;

    // Ensure the block is relatively positioned to hold the message correctly
    targetBlock.style.position = "relative";
    targetBlock.appendChild(message);

    setTimeout(() => {
      message.remove();
    }, 2000);
  }

  // Add a fadeOut animation
  const style = document.createElement("style");
  style.innerHTML = `
      @keyframes fadeOut {
        0% { opacity: 1; }
        80% { opacity: 1; }
        100% { opacity: 0; transform: translateY(-5px); }
      }
    `;
  document.head.appendChild(style);
});
